// extracted by mini-css-extract-plugin
export default {"controller":"DrawControllerWrapper_controller__tdbnP"};